import { render, staticRenderFns } from "./WhereListItem.vue?vue&type=template&id=2f554494&scoped=true&"
import script from "./WhereListItem.vue?vue&type=script&lang=js&"
export * from "./WhereListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f554494",
  null
  
)

export default component.exports